import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, HostBinding } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent implements ControlValueAccessor {

  @Input() title: string = '';
  // private _isSelected: boolean = false;
  @HostBinding('class.selected') _isSelected = false;
  @Input() hasError = false;
  @Input() isSoftInValid: boolean = false;
  @Input() warn: boolean = false;

  // @Input() select?: boolean = false;
  @Input() chip_id = 0;
  @Input('select')_value = false;
  // get select(): boolean {
  //   return this._isSelected;
  // }

  // @Input()
  // set select(value: boolean | undefined) {
  //   console.log(`set`, value);
  //   this._isSelected = value || false;
  //   this.onChipChange(value);

  // }

// @Output() onChangeValue = new EventEmitter<boolean>();

  constructor(
    private readonly _control: NgControl,
    private _cd: ChangeDetectorRef) {
    this._control.valueAccessor = this;
  }


   get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
    // this.onChangeValue.emit(this.value);
  }
  onChange: any = () => {};
  onTouched: any = () => {};

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value:  boolean) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  switch() {
    this.value = !this.value;

    // this.onChangeValue.emit(this.value);
  }
}
